import React from 'react';

import styled from 'styled-components';

import { getFormattedDate } from 'helpers/dates';
import { CommunityActivityType } from 'types/communities';

type ActivityBubbleOperationsProps = {
  activity: CommunityActivityType;
};

const Container = styled.div`
  position: relative;
  display: flex;
  min-width: 300px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 280px;
  max-width: 200px;
  padding: 10px 14px;
  border: 1px solid var(--line-gray);
  border-radius: 14px;
  background: #f7f8fb;
`;

const Content = styled.div`
  min-width: 0;
  color: var(--text-primary);
  font-size: 13px;
  word-break: break-word;
`;

const Author = styled.span`
  color: var(--text-secondary);
  font-size: 12px;
  white-space: nowrap;
`;

const Timestamp = styled.div`
  margin-left: auto;
  color: var(--text-secondary);
  font-size: 11px;
  white-space: nowrap;
  flex-shrink: 0;
`;

const ActivityBubbleOperations = ({ activity }: ActivityBubbleOperationsProps) => {
  const content = activity.body || activity.title;

  return (
    <Container>
      <Row>
        <Content>
          {content}
          {activity.actor?.name && <Author> by {activity.actor.name}</Author>}
        </Content>
        <Timestamp>{getFormattedDate(activity.occurred_at, 'MMM D, YYYY h:mm A')}</Timestamp>
      </Row>
    </Container>
  );
};

export default ActivityBubbleOperations;
